import React, { Component } from 'react';

class Extras extends Component {
  renderPersonalCards(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return (
        <article className="personal-card" key={item.title}>
          <span className="personal-kicker">{item.kicker}</span>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
          {item.url && (
            <a href={item.url} target="_blank" rel="noreferrer">
              {item.linkLabel}
            </a>
          )}
        </article>
      );
    });
  }

  renderPrinciples(items) {
    if (!Array.isArray(items)) {
      return null;
    }

    return items.map(function(item) {
      return (
        <li key={item}>
          <span className="principle-mark" aria-hidden="true">+</span>
          <span>{item}</span>
        </li>
      );
    });
  }

  render() {
    var data = this.props.data || {};

    return (
      <section id="extras" className="section extras-section">
        <div className="extras-grid">
          <div>
            <p className="eyebrow">Leadership</p>
            <h2>{data.heading}</h2>
            <p>{data.description}</p>
          </div>
          <div className="personal-grid">
            {this.renderPersonalCards(data.cards)}
          </div>
        </div>

        <ul className="principle-list">
          {this.renderPrinciples(data.principles)}
        </ul>
      </section>
    );
  }
}

export default Extras;
